'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

___$insertStyle("/*\n* ink colors (with variations only for black and white)\n*/\n.dm-root {\n  width: 100%;\n  margin-left: 30px;\n}\n.dm-root .ul, .dm-root .ul_parent {\n  list-style-type: none;\n  min-height: 36px;\n  margin: 0;\n  padding-left: calc(1.25 * 1rem);\n}\n.dm-root .ul_parent {\n  border: 1px solid #dfdfdf;\n  border-top: 0;\n  border-radius: 0 0 calc(0.25 * 1rem) calc(0.25 * 1rem);\n  margin-bottom: 2px !important;\n}");
//# sourceMappingURL=DesktopMenu.scss.js.map
